let times = value => {
    if (value != undefined) return value.split('T')[0]
}
let hoursTime = value => {
    if (value != undefined) return value.split('T')[0] + ' ' + value.split('T')[1].split(':')[0] + ':' + value.split('T')[1].split(':')[1]
}

let dateTime = value => {
    if (value != undefined) return new Date(value).toLocaleString()
}

let img = value => {
    if (value == '' || value == null) {
        return require("@/assets/index/dp-kong.png")
    }
    if (value != undefined) {
        return value.indexOf('http') > -1 ? value : `https://dpadmin.djplus.cn/Pimg/${value}`
    }
}
let img2 = value => {
    if (value == '' || value == null) {
        return require("@/assets/index/dp-kong.png")
    }
    if (value != undefined) {
        return value.indexOf('http') > -1 ? value : `http://qswgadmin.djplus.cn/Tittle/${value}`
    }
}

let hidePhone = value => {
    return value.replace(/^(\d{3})\d{4}(\d{4})$/, '$1****$2')
}

import { baseURL } from '@/utils/baseURL.js'
// http://192.168.2.212:16928
let filterB = value => {
    // console.log(value);
    if (value != "" && value) {
        return value.indexOf("base64") > -1
            ? value
            : `${baseURL}/UserImg/${value}`;
            // : `http://192.168.2.212:16928/UserImg/${value}`;
    }
    else {
        return require("@/assets/partyreports/touxiang-big.png")
    }
}
let filterC = value => {
    // console.log(value);
    if (value != "")
        return value.indexOf("base64") > -1
            ? value
            : `${baseURL}/Voucher/${value}`;
            // : `http://192.168.2.212:16928/Voucher/${value}`;
    else {
        return require("@/assets/partyreports/touxiang-big.png")
    }
}
export {
    times,
    img,
    hidePhone,
    dateTime,
    filterB,
    hoursTime,
    filterC,
    img2
}